module.exports = __webpack_public_path__ + "img/Dantam Fashion 12.8761501a.jpg";